const initCookiesBar = () => {
	const cookieStatus = (document.cookie
		.match(/^(?:.*;)?\s*cookie_policy_accepted\s*=\s*([^;]+)(?:.*)?$/) || [null])[1];
	if (cookieStatus !== 'yes') {
		document.querySelector('.cookies-bar').classList.remove('-hide');
		document.getElementById('acceptCookies').addEventListener('click', () => {
			document.cookie = 'cookie_policy_accepted=yes';
			document.querySelector('.cookies-bar').classList.add('-hide');
		});
	}
};

export default initCookiesBar;



// WEBPACK FOOTER //
// ./src/js/common/initCookiesBar.js